/**
 * PHARMAKON — the views of Stock & lots and their URL (cross-module
 * 02_DESIGN §3.1 `vue` grammar, §3.3 « Stock alerts deep link »; WP-18;
 * X XWP-15 — refonte ux/04 §2.1.1).
 *
 * `/stock?vue=<view>` is the deep-link target of the topbar entries
 * (« N alertes stock » → `alertes`, « n lots périmés » → `perimes`); the
 * Stock & lots page keeps its view in the same parameter so a link always
 * reproduces what was seen. Values mirror the server's `STOCK_VUES`
 * (`apps/server/src/config/stock-liste.config.js`); which views a role sees
 * and their counts come from `GET /stock/alertes/compteurs` (`vues`).
 */

/** Query parameter of the Stock & lots view. */
export const STOCK_VIEW_PARAM = "vue";

/** View values (cross-module 02_DESIGN §3.1). `tous` is the default (omitted). */
export const STOCK_VIEWS = Object.freeze({
  TOUS: "tous",
  ALERTES: "alertes",
  RUPTURES: "ruptures",
  STOCK_BAS: "stock_bas",
  PER_30: "per_30",
  PER_90: "per_90",
  PERIMES: "perimes",
  EPUISES: "epuises",
  BLOQUES: "bloques",
});

/**
 * The views strip, in display order (ux/04 §2.1.1 plus « Alertes stock » and « Bloqués », X §3.1).
 * `lignes` = what a row is; the péremption labels are built from the server thresholds
 * (`compteurs.seuils`), never a literal (AUD-STOCK-06).
 */
export const STOCK_VUES_ORDRE = Object.freeze([
  Object.freeze({ value: STOCK_VIEWS.TOUS, label: "Tous les lots", court: "Tous", lignes: "lots" }),
  Object.freeze({ value: STOCK_VIEWS.ALERTES, label: "Alertes stock", court: "Alertes", lignes: "produits" }),
  Object.freeze({ value: STOCK_VIEWS.RUPTURES, label: "Ruptures", court: "Ruptures", lignes: "produits" }),
  Object.freeze({ value: STOCK_VIEWS.STOCK_BAS, label: "Stock bas", court: "Stock bas", lignes: "produits" }),
  Object.freeze({ value: STOCK_VIEWS.PER_30, seuil: "per_30", lignes: "lots" }),
  Object.freeze({ value: STOCK_VIEWS.PER_90, seuil: "per_90", lignes: "lots" }),
  Object.freeze({ value: STOCK_VIEWS.PERIMES, label: "Périmés", court: "Périmés", lignes: "lots" }),
  Object.freeze({ value: STOCK_VIEWS.EPUISES, label: "Épuisés", court: "Épuisés", lignes: "lots" }),
  Object.freeze({ value: STOCK_VIEWS.BLOQUES, label: "Bloqués", court: "Bloqués", lignes: "lots" }),
]);

/** URL keys of the page's own state (filters live under their API names). */
export const STOCK_PARAMS = Object.freeze({
  RECHERCHE: "q",
  PAGE: "page",
  FOCUS: "focus",
  PRODUIT_PANNEAU: "produit",
  LOT: "lot",
  INCLURE_EPUISES: "inclure_epuises",
  PRODUIT_FILTRE: "produit_id",
});

/** Route of the Stock & lots page. */
export const STOCK_ROUTE = "/stock";

/** `/stock?vue=<view>` (the default view has no parameter). */
export function stockViewPath(view) {
  if (!view || view === STOCK_VIEWS.TOUS) return STOCK_ROUTE;
  return `${STOCK_ROUTE}?${STOCK_VIEW_PARAM}=${encodeURIComponent(view)}`;
}

/**
 * X XD-139 → XWP-15 — « Voir dans Stock & lots » from the product panel: the lots of that product
 * (the `produit_id` filter of the grammar), never a text search on its name.
 */
export function stockProduitPath(produitId) {
  return `${STOCK_ROUTE}?${STOCK_PARAMS.PRODUIT_FILTRE}=${encodeURIComponent(produitId)}`;
}
